import { store } from '~/store';

export const isLoggedIn = () => {
  const state = store.getState();
  return state.currentAccount.id ? true : false;
};

export const logIn = () => {
  if (window.cm_settings?.authURL) {
    window.location.assign(window.cm_settings.authURL);
  }
};
